export type ResponseContractIssue = Readonly<{
  path: string
  code: string
  message: string
}>

export type RequestSemantics = 'form-request' | 'page-request'

export type ResponseRequestContext = Readonly<{
  id: string
  semantics: RequestSemantics
  action: 'explicit' | 'background'
  component?: string
  operation?: string
  url?: string
  status?: number
}>

export class ResponseContractError extends Error {
  readonly contract: string
  readonly issues: readonly ResponseContractIssue[]
  readonly safeValues: Readonly<Record<string, unknown>>

  constructor({
    contract,
    issues,
    safeValues = {},
  }: {
    contract: string
    issues: readonly ResponseContractIssue[]
    safeValues?: Readonly<Record<string, unknown>>
  }) {
    super('Application response did not match its frontend contract.')
    this.name = 'ResponseContractError'
    this.contract = contract
    this.issues = issues
    this.safeValues = safeValues
  }
}
